import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { faCaretCircleDown } from "@fortawesome/pro-solid-svg-icons";
import { GlobalHeaderDataService } from "../global-header-data.service";
import { SetSSOSettings } from "src/app/store/actions/global-header.actions";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/store/state/app.state";
import { environment } from "../../../environments/environment";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-global-sso-menu",
  templateUrl: "./global-sso-menu.component.html",
  styleUrls: ["./global-sso-menu.component.scss"],
})
export class GlobalSsoMenuComponent implements OnInit {
  faCaretDown = faCaretDown;
  faCaretCircleDown = faCaretCircleDown;
  inboxLink = "";
  modelManagementLink = "";
  oneAccessLink = "";
  assetUrl = environment.assetUrl;
  @Input() globalSettingsReady = false;
  @Output() SSOApiReady: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private dataService: GlobalHeaderDataService,
    private appService: AppService,
    private store: Store<AppState>,
  ) {}

  ngOnInit(): void {
    this.dataService.getIsDEActive().subscribe(
      (data) => {
        if(!data.status){
          this.modelManagementLink = data.url;
        }
        const ssoObj = {
          modelManagementLink: this.modelManagementLink,
          oneAccessLink: this.oneAccessLink,
        };
        this.store.dispatch(
          new SetSSOSettings(this.appService.deepClone(ssoObj)),
        );
        const apiReady =
          this.modelManagementLink !== null || this.oneAccessLink !== null;
        this.SSOApiReady.emit(apiReady);
      },
      (error) => {
        console.error(error);
      },
    );
    this.dataService.getIsOneAccessActive().subscribe(
      (data) => {
        if(!data.status){
          this.oneAccessLink = data.url;
        }
        const ssoObj = {
          modelManagementLink: this.modelManagementLink,
          oneAccessLink: this.oneAccessLink,
        };
        this.store.dispatch(
          new SetSSOSettings(this.appService.deepClone(ssoObj)),
        );
        const apiReady =
          this.modelManagementLink !== null || this.oneAccessLink !== null;
        this.SSOApiReady.emit(apiReady);
      },
      (error) => {
        console.error(error);
      },
    );
  }
}
